import type { OnboardingChecklistStep } from '../shared/types';
import { CUSTOMER_STEP } from './customer/checklist-item';
import { ORDER_STEP } from './order/checklist-item';

// Setup handles the price list; the tutorial is the try-it-out loop: pick a customer, then order as them.
const TUTORIAL_CHECKLIST_STEP = {
  CUSTOMER: CUSTOMER_STEP,
  ORDER: ORDER_STEP,
} as const satisfies Record<Uppercase<string>, OnboardingChecklistStep>;

// Ordered tutorial sequence; order defines which step is "next" (first incomplete). Shared by the checklist and next-step banner.
export const DEFAULT_TUTORIAL_STEPS: OnboardingChecklistStep[] = [
  TUTORIAL_CHECKLIST_STEP.CUSTOMER,
  TUTORIAL_CHECKLIST_STEP.ORDER,
];
